import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Payment method badges — displayed as branded pills.
 * Uses SVG-encoded brand marks so we don't depend on external CDNs.
 * Variants: "dark" (for black bg) | "light" (for white bg).
 */
const METHODS = [
  { label: "BCA VA", color: "#0060af", fg: "#ffffff" },
  { label: "GoPay", color: "#00aed6", fg: "#ffffff" },
  { label: "ShopeePay", color: "#ee4d2d", fg: "#ffffff" },
  { label: "QRIS", color: "#e42e28", fg: "#ffffff" },
  { label: "VISA", color: "#1a1f71", fg: "#f7b600" },
  { label: "Mastercard", color: "#ffffff", fg: "#eb001b", ring: true },
];

export default function PaymentLogos({ variant = "dark", showCaption = true, testid = "payment-logos" }) {
  const isDark = variant === "dark";
  const captionColor = isDark ? "text-neutral-400" : "text-neutral-600";
  const iconColor = isDark ? "text-[#e6c98a]" : "text-[#8a6a2e]";
  return (
    <div className="flex flex-col items-center gap-3" data-testid={testid}>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {METHODS.map((m) => (
          <span
            key={m.label}
            data-testid={`payment-${m.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={`inline-flex select-none items-center justify-center rounded-md px-3 py-1.5 text-[11px] font-bold tracking-wide shadow-sm ${
              m.ring ? "ring-1 ring-neutral-300" : ""
            }`}
            style={{ background: m.color, color: m.fg, fontFamily: "'Inter', sans-serif", letterSpacing: "0.03em" }}
          >
            {m.label}
          </span>
        ))}
      </div>
      {showCaption && (
        <p className={`inline-flex items-center gap-1.5 text-[11px] ${captionColor}`} style={{ fontFamily: "'Inter', sans-serif" }}>
          <ShieldCheck className={`h-3.5 w-3.5 ${iconColor}`} />
          Pembayaran diproses aman oleh <b className={iconColor}>Midtrans</b>
        </p>
      )}
    </div>
  );
}
